import React, { useState } from "react";

export default function Textbox(props) {
  const handleOnChange = (event)=>{
    setText(event.target.value);
  }
  const handleUpCase = ()=>{
    console.log("upCase was clicked");
    let upCaseText = text.toUpperCase();
    setText(upCaseText);
  }
  const handleLowerCase = ()=>{
    console.log("lowerCase was clicked");
    let lowerCaseText = text.toLowerCase();
    setText(lowerCaseText);
  }
  const handleClear = ()=>{
    console.log("clear was clicked");
    setText("");
  }
  const handleTrim = ()=>{
    console.log("trim was clicked");
    let trimText = text.trim();
    setText(trimText);
  }
  const handleCopy = ()=>{
    // Get the text field
  var copyText = text;
  navigator.clipboard.writeText(copyText);
  // Alert the copied text
  // alert("Copied the text: " + copyText);
  }
  const handleExtraSpace = ()=>{
    let newText = text.split(/[ ]+/);
    setText(newText.join(" "));
  }
  const [text, setText] = useState("");
  return (
    <div>
        <h2 className="my-4" style={{color: props.mode === 'dark'? 'white': 'black'}}>Simply enter your text and choose the case you want to convert it to</h2>
        <textarea
          className={`form-control bg-${props.mode} text-${props.mode === 'dark'? 'white': 'black'}`}
          placeholder="Leave a comment here"
          id="floatingTextarea2"
          onChange={handleOnChange}
          value={text}
          style={{height: "250px"}} 
          // color: props.mode === 'dark'? 'white': 'black',backgroundColor: props.mode === 'dark'? 'black': 'white'
        ></textarea>
      <div className="d-flex mb-3">
      <button type="button" className="btn btn-primary my-2 mx-2 p-2" onClick={handleUpCase}>Upper Case</button>
      <button type="button" className="btn btn-primary my-2 mx-2 p-2" onClick={handleLowerCase}>Lower Case</button>
      <button type="button" className="btn btn-primary my-2 mx-2 p-2" onClick={handleTrim}>Trim Text</button>
      <button type="button" className="btn btn-primary my-2 mx-2 p-2" onClick={handleExtraSpace}>Remove Extra Space</button>
      <button type="button" className="btn btn-danger my-2 mx-2 p-2" onClick={handleClear}>Clear Text</button>
      <button type="button" className="btn btn-success my-2 mx-2 ms-auto p-2" onClick={handleCopy}>Copy</button>
      </div>
<div style={{color: props.mode === 'dark'? 'white': 'black'}}>
      <h3 className="my-3" >Text Report</h3>
      <p>Character count: {text.length} <br />
      Word count: {text.split(" ").length-1} <br />
      Minutes takes to read: {`${text.length-1 > 0 ? 0.008*text.split(" ").length:'0'}`}
      </p>

      <h3>Preview</h3>
      <p className={`${text.length-1 > 0 ? 'border':''}`}>{text}</p>
</div>
    </div>
  );
}
